/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Directive, effect, input, output } from '@angular/core';
import { Telework } from '../telework';
import { Dayjs } from 'dayjs';

@Directive({
  standalone: true,
  selector: '[inflDayRow]',
})
export class DayRowDirective {
  public resource = input<string>();
  public date = input<Dayjs>(null);
  public teleworks = input<Telework[]>([]);

  public hasTelework = output<void>();

  constructor() {
    effect(() => {
      if (this.teleworks() && this.teleworks().length > 0) {
        const telework = this.teleworks().find((t) => {
          return (
            t.resourceId === this.resource() &&
            t.date === this.date().format('DD/MM/YYYY')
          );
        });
        if (telework) {
          this.hasTelework.emit();
        }
      }
    });
  }
}
